<template>    
    <div class="py-4 container-fluid">
        <transition name="banner-slide">
            <div v-if="isSyncing || progress === 100">
                <RvoSyncBanner />
            </div>
        </transition>
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <!--i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">pets</i-->
                            <img src="@/assets/img/animal.svg" class="opacity-10 text-white" style="width: 28px;margin-top: 17px;" />
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('animal.My_animals') }}</h6>
                        <div class="row" :style="userRoleName != 'Keeper' ? { marginTop: '-30px' } : {}">
                            <div class="col-lg-2">
                            </div>
                            <div class="col-lg-10">
                                <div class="d-flex justify-content-end align-items-center gap-2">                                    
                                    <div class="btn-group" v-if="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'" style="margin-top: 15px;">
                                        <span class="btn btn-sm bg-gradient-success text-nowrap" style="width: 150px;">
                                            {{ $t('settings.Association') }}
                                        </span>
                                        <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span class="visually-hidden">{{ $t('settings.Select_association') }}</span>
                                        </button>

                                        <ul class="dropdown-menu dropdown-menu-end custom-association-dropdown">
                                            <li>
                                                <input
                                                    ref="searchInput" v-model="searchQuery" type="text" class="form-control form-control-sm" :placeholder="$t('animal.Search_UBN')" style="display: block !important;"/>
                                                <span
                                                    class="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" style="cursor: pointer;" @click="clearAssociationSelection">
                                                    &times;
                                                </span>
                                            </li>
                                            <li><hr class="dropdown-divider" /></li>                                        
                                            <!-- Associations and UBNs -->
                                            <li v-for="assoc in filteredAssociations" :key="assoc.associationId">
                                                <span class="dropdown-item text-bold text-dark fs-12">
                                                    {{ assoc.abbreviation || assoc.name }}
                                                </span>
                                                <ul class="list-unstyled ms-3">
                                                    <li
                                                        v-for="ubn in assoc.ubns"
                                                        :key="ubn.locationId"
                                                        @click="selectUbn(assoc.associationId, assoc.abbreviation || assoc.name, ubn.locationId, ubn.ubn)"
                                                        class="dropdown-item  fs-12"
                                                    >
                                                        {{ ubn.ubn }}
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                    
                                                                        
                                    <div class="btn-group" style="margin-top: 15px;">
                                        <button
                                            type="button"
                                            class="btn btn-sm bg-gradient-success text-nowrap"
                                            :class="{ disabled: !associationId || !ubnId || isCheckingRvo }"
                                            :disabled="!associationId || !ubnId || isCheckingRvo"
                                            style="width: 150px;"
                                            @click="checkRvo"
                                        >
                                            <span v-if="isCheckingRvo">
                                                {{ $t('common.Loading') }}
                                            </span>
                                            <span v-else>
                                                {{ $t('sidemenu.Check_RVO') }}
                                            </span>
                                        </button>                                        
                                    </div>
                                </div>                                                                
                            </div>
                        </div>
                    </div>                    
                    <div class="table-responsive" :class="{ 'mt-5': ['Inspector', 'Admin'].includes(userRoleName) }" ref="tableWrapper">                        
                        <div class="rvo-legend mb-3">
                            <div class="rvo-legend-item">
                                <span class="rvo-legend-color rvo-legend-red"></span>
                                <span>Dier geregistreerd in VeeBoek, maar niet in RVO</span>
                                <!--Animal registered in VeeBoek, but not in RVO-->
                            </div>

                            <div class="rvo-legend-item">
                                <span class="rvo-legend-color rvo-legend-blue"></span>
                                <span>Dier geregistreerd in RVO, maar niet in VeeBoek</span>
                                <!--Animal registered in RVO, but not in VeeBoek-->
                            </div>

                            <div class="rvo-legend-item">
                                <span class="rvo-legend-color rvo-legend-black"></span>
                                <span>Dier geregistreerd in zowel RVO als VeeBoek</span>
                                <!--Animal registered in both RVO and VeeBoek-->
                            </div>
                        </div>
                        <table
                            :key="tableKey"
                            id="animal-list"
                            class="table table-flush"
                            ref="animalTable"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th v-for="col in activeColumns" :key="col.key">
                                        <p class="mb-0 text-xs font-weight-bold">
                                            {{ col.label }}
                                        </p>
                                    </th>
                                    <th data-sortable="false"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="animal in filteredAnimals"
                                    :key="`a-${animal.id}`"
                                    :class="{
                                        'rvo-not-found-row':
                                            animal.isInRvo === false,

                                        'rvo-only-row':
                                            animal.isInRvo === true &&
                                            animal.isInVeeBoek === false,

                                        'rvo-and-veeboek-row':
                                            animal.isInRvo === true &&
                                            animal.isInVeeBoek === true
                                    }"
                                >
                                    <!-- Animal data -->
                                    <td v-for="col in activeColumns" :key="`c-${col.key}`">
                                        {{ animal[col.key] }}
                                    </td>
                                    <!-- Actions -->
                                    <td>
                                        <div class="float-end">
                                            <!-- Actions are ONLY available when the animal exists in VeeBoek-->
                                            <template v-if="animal.isInVeeBoek === true">                                                
                                                <!-- Preview 
                                                <button :data-id="animal.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success preview-button" style="margin-right: 10px !important;" :title="$t('common.Details')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">preview</i>
                                                </button>
                                                -->
                                                <!-- Edit -->
                                                <button v-if="!['Keeper', 'Inspector'].includes(userRoleName)" :data-id="animal.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                                </button>
                                            </template>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>                        
                    </div> 
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import axios from 'axios';
import { DataTable } from "simple-datatables";
import RvoSyncBanner from "@/components/RvoSyncBanner.vue";
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'Myanimal_checkrvo_page',    
    components: {
        RvoSyncBanner
    },
    data() {
        return {
            associationId: '',
            associationName: '',
            ubnId: '',
            selectedUbn: '',

            associations: [],
            animals: [],

            searchQuery: '',

            isCheckingRvo: false,

            gets: [],
            dataTableInstance: null,            
            choicesInstanceAssociation: null,
            hover: false,
            animalListClickBound: false,
            tableKey: 0,
        }
    },
    computed: {
        ...mapState('rvoSync', ['isSyncing', 'progress', 'cancelSource']),
        ...mapGetters('rvoSync', ['elapsedSeconds']),

        userRoleName() {
            return this.$store.state.user?.roleName;
        },

        filteredAssociations() {
            if (!Array.isArray(this.associations)) {
                return [];
            }

            const search = (this.searchQuery || '')
                .trim()
                .toLowerCase();

            if (!search) {
                return this.associations;
            }

            return this.associations
                .map(assoc => {

                    const associationMatches =
                        (assoc.name || '')
                            .toLowerCase()
                            .includes(search) ||
                        (assoc.abbreviation || '')
                            .toLowerCase()
                            .includes(search);

                    const matchingUbns = Array.isArray(assoc.ubns)
                        ? assoc.ubns.filter(ubn =>
                            (ubn.ubn || '')
                                .toLowerCase()
                                .includes(search)
                        )
                        : [];

                    if (associationMatches) {
                        return assoc;
                    }

                    if (matchingUbns.length > 0) {
                        return {
                            ...assoc,
                            ubns: matchingUbns
                        };
                    }

                    return null;
                })
                .filter(Boolean);
        },

        // Columns displayed in the RVO animal table
        activeColumns() {
            return [
                {
                    key: 'tagNumber',
                    label: this.$t('animal.Tag_number')
                },
                {
                    key: 'animalNumber',
                    label: this.$t('animal.Registration_No')
                },
                {
                    key: 'birthDate',
                    label: this.$t('animal.Date_of_birth')
                },
                {
                    key: 'gender',
                    label: this.$t('animal.Gender')
                },
                {
                    key: 'ubn',
                    label: this.$t('animal.UBN')
                }
            ];
        },

        // Animals returned by GetAllAnimals()
        filteredAnimals() {
            if (!Array.isArray(this.animals)) {
                return [];
            }

            return this.animals;
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);

            // Only Admin and AssociationAdmin can use this page
            if (!['Admin', 'AssociationAdmin'].includes(this.userRoleName)) {
                await this.$router.replace({ name: 'Home' });
                return;
            }

            // Load associations + UBNs for selection
            await this.fetchAllAssociationData();
            
            this.animals = [];

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    beforeUnmount() {
        this.destroyDataTable();
    },    
    methods: {
      
        // central place to translate labels per key        
        colLabel(key) {
            const map = {
                studbookNumber: this.$t('animal.Studbook_number'),
                tagNumber: this.$t('animal.Tag_number'),
                ubn: this.$t('animal.UBN'),
                animalNumber: this.$t('animal.Registration_No'),
                name: this.$t('animal.Name'),
                breedName: this.$t('animal.Breed'),
                gender: this.$t('animal.Gender'),
                birthDate: this.$t('animal.Date_of_birth'),
                breederName: this.$t('animal.Breeder'),
                keeperName: this.$t('animal.Keepername'),
            };
            return map[key] ?? key;
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        },
        async initDataTable() {

            await this.$nextTick();

            const table = this.$refs.animalTable;

            if (!table || !table.parentNode) {
                console.warn("Table or its parent not found. Skipping DataTable init.");
                return;
            }

            // Don't initialize twice
            if (this.dataTableInstance) {
                console.warn("DataTable already initialized.");
                return;
            }

            this.dataTableInstance = new DataTable(table, {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,

                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: true },
                    { select: 3, sortable: true },
                    { select: 4, sortable: true },
                    { select: 5, sortable: false }
                ],

                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search')
                }
            });

            table.addEventListener('click', this.handleTableClick);
        }, 
        destroyDataTable() {

            const table = this.$refs.animalTable;

            // Remove our event listener first
            if (table) {
                table.removeEventListener('click', this.handleTableClick);
            }

            // Destroy simple-datatables
            if (this.dataTableInstance) {
                try {
                    this.dataTableInstance.destroy();
                } catch (error) {
                    console.warn("Error destroying DataTable:", error);
                }

                this.dataTableInstance = null;
            }
        },
        handleTableClick(event) {
            const targetElement = event.target.closest('[data-id]');
            if (!targetElement) return;

            const id = targetElement.getAttribute('data-id');
            if (!id) return;

            if (event.target.closest('.edit-button')) {
                this.$router.push({ name: 'Edit Animal', params: { id } });
            } else if (event.target.closest('.preview-button')) {
                this.$router.push({ name: 'Preview Animal', params: { id } });
            } else if (event.target.classList.contains('delete-button')) {
                this.deleteLocation(id);
            }
        },                     
        clearAssociationSelection() {
            this.associationId = '';
            this.ubnId = '';
            this.searchQuery = '';
        },
        selectUbn(associationId, associationName, ubnId, ubn) {
            this.associationId = associationId;
            this.associationName = associationName + ' - ' + ubn;
            this.ubnId = ubnId;
        },
        async checkRvo() {

            if (!this.associationId || !this.ubnId) {
                return;
            }

            this.isCheckingRvo = true;

            try {

                this.$store.commit('setShowLoading', true);

                const selectedAssociation = this.associations.find(a => a.associationId == this.associationId);
                const selectedUbn = selectedAssociation?.ubns?.find(u => u.locationId == this.ubnId);

                if (!selectedUbn?.ubn) {
                    this.$showError('UBN kon niet worden bepaald.');
                    return;
                }

                // Store selected UBN
                this.selectedUbn = selectedUbn.ubn;

                const cancelSource = axios.CancelToken.source();
                this.$store.commit("rvoSync/START_SYNC", cancelSource);
                await this.$nextTick();

                const payload = {
                    associationId: this.associationId,
                    rvoRelationnumber: selectedUbn.rvoRelationnumber,
                    ubn: selectedUbn.ubn
                };

                // 1. Sync RVO
                const syncResponse = await axios.get(
                    'rvo/syncrvoanimals',                    
                    {
                        params: payload,
                        cancelToken: cancelSource.token
                    }
                );

                const syncResult = syncResponse.data;
                if (!syncResult.success) {
                    this.$showError(syncResult.message || 'RVO synchronisatie is mislukt.');
                    return;
                }

                // 2. Load combined VeeBoek + RVO animals
                await this.loadAnimals();
            }
            catch (e) {

                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`
                );
            }
            finally {
                this.isCheckingRvo = false;
                this.$store.commit("rvoSync/STOP_SYNC");
                this.$store.commit('setShowLoading', false);
            }
        },  
        async loadAnimals() {

            if (!this.selectedUbn) {
                return;
            }

            try {

                this.$store.commit('setShowLoading', true);

                // 1. Destroy the existing DataTable
                this.destroyDataTable();

                // 2. Force Vue to create a completely new table
                this.tableKey++;

                // 3. Wait until the new table exists
                await this.$nextTick();

                // 4. Load animals for selected UBN
                const response = await axios.get(
                    'Animal/getallanimals',
                    {
                        params: { ubn: this.selectedUbn }
                    }
                );

                const result = response.data;

                if (!result.success) {
                    this.$showError(result.message || 'Dieren ophalen mislukt.');
                    return;
                }

                // 5. Set new animals
                this.animals = Array.isArray(result.data)
                    ? result.data.map(animal => ({
                        ...animal,
                        birthDate: this.formatDate(animal.birthDate)
                    }))
                    : [];

                if (this.animals.length === 0) {
                    this.$showSuccess('errors.Success_no_animal_found');
                }

                // 6. Let Vue render the new rows
                await this.$nextTick();

                // 7. Initialize DataTable on fresh table
                await this.initDataTable();

            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.animals = [];
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },           
        async fetchAllAssociationData() {
            try {
                const response = await axios.get("association/getassociationswithubns");
                const result = response.data;

                if (!result.success || !Array.isArray(result.data)) {
                    this.associations = [];
                    return;
                }

                this.associations = result.data;

                console.log('Associations:', this.associations);
                console.log('First association UBNs:', this.associations[0]?.ubns);
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        async deleteAnimalModal(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {                        
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("Animal/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                try {
                                    const fetchResponse = await axios.get("Animal/getall");
                                    const fetchResult = fetchResponse.data;

                                    if (fetchResult.success) {
                                        this.animals = fetchResult.data
                                            .map(a => ({ ...a, birthDate: this.formatDate(a.birthDate) }))
                                            .sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));

                                        // Destroy + reinit to avoid parentNode null
                                        if (this.dataTableInstance) {
                                            try { this.dataTableInstance.destroy(); } catch { console.log('Error')}
                                            this.dataTableInstance = null;
                                        }
                                        this.tableKey++;
                                        await this.$nextTick();
                                        await this.initAnimalDataTable();

                                        this.$showSuccess('errors.Success_record_is_deleted_successfully');
                                    } else {
                                        throw new Error('Failed to fetch updated animal list.');
                                    }
                                } catch (e) {
                                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                                }
                            } else {                                    
                                this.$showError('errors.Contact_system_admin');
                            }                            
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        } finally {
                            this.$store.commit('setShowLoading', false);
                        }
                    }
                });            
        }        
    }
}
</script>
<style scoped>
    ::v-deep .choices {
        width: auto !important;
        min-width: 270px;
    }
    .dead-animal-row {
        background-color: #f8d7da !important; /* light red */
        color: #721c24; /* dark red text */
    }
    .transferred-animal-row {
        background-color: #fdd199 !important;
        color: #643800;
    }
    .download-link {
        display: inline-flex;
        align-items: center; /* vertically centers icon & text */
        gap: 4px;            /* spacing between icon and text */
        text-decoration: none; /* prevent underline on whole link */
    }
    .disabled-look {
        opacity: 0.65;
        pointer-events: none;
    }
    .underline-text {
        text-decoration: underline;
        text-underline-offset: 2px;
    }
    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    .fs-12 {
        font-size: 12px !important;
    }
    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .search-txt {
        max-width: 350px;
        border: 1px solid #d2d2d2;
        font-size: 0.875rem;
        color: #495057;
        border-radius: .375rem;
        padding: 6px 12px;
    }

    .search-txt:focus {
        border: 1px solid #4ca750 !important;
        box-shadow: none !important;
        outline: none !important;
    }

    .rvo-not-found-row {
        background-color: #f8d7da !important;
        color: #721c24 !important;
    }

    .rvo-only-row {
        background-color: #cfe2ff !important;
        color: #084298 !important;
    }

    .rvo-and-veeboek-row {
        background-color: #ffffff !important;
        color: #000000 !important;
    }

    .rvo-legend {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        align-items: center;
        padding: 10px 15px;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        background: #f8f9fa;
    }

    .rvo-legend-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 500;
    }

    .rvo-legend-color {
        width: 18px;
        height: 18px;
        display: inline-block;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
    }

    .rvo-legend-red {
        background-color: #f8d7da;
    }

    .rvo-legend-blue {
        background-color: #cfe2ff;
    }

    .rvo-legend-black {
        background-color: #ffffff;
        border: 2px solid #000;
    }
</style>